// extracted by mini-css-extract-plugin
export default {"container":"static_container__jVEiD","vertical":"static_vertical__E1Ah8","vertical_subtext":"static_vertical_subtext__G2Mci","icon":"static_icon__4l1aT"};